// photoData.js

const importAll = (r) => {
    return r.keys().map((fileName) => {
      const id = fileName.replace('./', '').split('.')[0]; // Use the filename as ID
      return { id, src: r(fileName), alt: `Photo ${id}` };
    });
  };
  
  // Adjust the regex to capture various image formats
  const group1Images = importAll(require.context('../../images/gallery-images/opening-2020', false, /\.(png|jpe?g|JPE?G|jpg|gif|svg|bmp|tiff|webp)$/i));
  const group2Images = importAll(require.context('../../images/gallery-images/honnavar-opening', false, /\.(png|jpe?g|JPE?G|jpg|gif|svg|bmp|tiff|webp)$/i));
  const group3Images = importAll(require.context('../../images/gallery-images/kavalakki-opening', false, /\.(png|jpe?g|JPE?G|jpg|gif|svg|bmp|tiff|webp)$/i));

  
  const photoGroups = [
    {
      title: "Inauguration of Supreet Souharda Society",
      description: "The grand opening ceremony of Supreet Souharda Co-operative Society Ltd., Kelaginoor, marking the beginning of our journey to serve the community with trust and dedication.",
      images: group1Images,
    },
    {
      title: "Inauguration of Our New Branch at Honavar",
      description: "Supreet Souharda Co-operative Society Ltd., Kelaginoor, proudly inaugurated its New Branch at Honavar on Monday, 21st April 2025 at Shakuntala Arcade, Bazar Road, Honavar.",
      images: group2Images,
    },
    {
      title: "Opening of Our Kavalakki Branch",
      description: "Supreet Souharda Co-operative Society Ltd., Kelaginoor, inaugurated its Kavalakki Branch on Friday, 14th November 2025 at Govardhan Complex, Kavalakki, blessed by Rev. Fr. Wilson Noronha and Rev. Fr. David Pinto.",
      images: group3Images,
    },
  ];
  
  export default photoGroups;
  